import {
    commonCaseReportInputStream,
    commonCaseReportUri,
    commonCaseReportUrl
} from '@/api/resources/common/commonCaseReportServices/commonCaseReportServices.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { SupportedFileType } from '@/shared/models/common.models'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'
import { SidebarTimeFilterType } from '@/components/sideBar/filters/time-filter/sidebar-filters-time-filter.model'

export interface CommonModalConfig {
    storeName: string,
    uiComponent: string,
    name: string,
    checkable: string,
    content: string,
}

export interface CommonSampleFamilyTreeRequest {
    caseId: number,
    sampleId: number
}

export interface CommonPortionFamilyTreeRequest extends CommonSampleFamilyTreeRequest {
    portionId?: number,
}

export interface CommonSubportionFamilyTreeRequest extends CommonPortionFamilyTreeRequest {
    subportionId?: number
}

export interface CommonResource {
    description: string
    file: File
    filename: string
    inputStream: commonCaseReportInputStream
    open: boolean
    readable: boolean
    uri: commonCaseReportUri
    url: commonCaseReportUrl
}

export interface CommonFilterModel {
    [key: string]: { [key: string]: any }
}

export interface CommonParams {
    sort?: string[]
    page?: number
    size?: number
}

export interface CommonParamsWithQuery extends CommonParams {
    query: string
}

export enum CommonExportType {
    PDF = 'PDF',
    EXCEL = 'XLSX'
}
export interface ExportCommonParams extends CommonParams {
    exportType?: CommonExportType
}

export interface CommonSearchResponse {
    id: number
    label: string
}

export interface CommonPaginatorResourceService<T> {
    paginator(filterModel: CommonFilterModel, params: CommonParams, ...restOfParams: any[]): Promise<IResponseAgGrid<T>>
}
export interface CommonPaginatorLaboratoryResourceService<T> {
    paginator(laboratoryId: number, filterModel?: CommonFilterModel, params?: CommonParams, ...restOfParams: any[]): Promise<IResponseAgGrid<T>>
    export?(laboratoryId: number, gridColumns?: ReportGridRequest, params?: ExportCommonParams, ...restOfParams: any[]): Promise<AxiosResponse<Blob>>
}

export interface CommonSortModelResource {
    colId?: string
    sort?: string | null
}

///

export interface VtSidebarCustomConfig {
    sidebarName: string
    sidebarTimeFilter?: SidebarTimeFilterType
    defaultOptionId?: string
}
export interface VtCustomFilter {
    filterModel: CommonFilterModel
}

export interface CommonOpenFileParams {
    blob: Blob
    type?: SupportedFileType
    newWindowTabTitle?: string
}
